import { useState } from "react";
import axiosInstance from "../../../services/axiosComman";
import { ViewMoreIcon } from "../../../assets/icons";
import Swal from "sweetalert2";
import { GetAccess } from "../../../utils/RolesandAccess";
import CreateorUpdate from "./form";
import UserProfile from "./UserProfile";
import ChangePassword from "./ChangePassword";
import { toast } from "react-toastify";

function Viewmore({ fetcher, data, standard, viewData, depList }) {
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false);
  const [showPassword, setShowPassword] = useState(false);
  const handlePasswordOnClose = () => setShowPassword(false);

  const handleDelete = async (id, value) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Delete ${value}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (id) {
          await axiosInstance
            .delete(`/User/${id}`)
            .then((res) => {
              if (res.status == 200) {
                fetcher();
                toast.success(
                  <p className="test-sm">
                    {`${res.data.msg || res.data.message}` ||
                      "User Deleted Successfully"}
                  </p>
                );
              } else {
                toast.error(
                  <p className="test-sm">
                    {`${res.data.msg || res.data.message}` ||
                      "User Deleted Unsuccessfully"}
                  </p>
                );
              }
            })
            .catch((err) => {
              toast.error(
                <p className="test-sm">{`${
                  err.response.data.msg ||
                  err.response.data.message ||
                  err.response.data.error ||
                  "User Added Unsuccessfully"
                }`}</p>
              );
            });
        }
      }
    });
  };
  return (
    <>
      <div className=" w-8 h-8 flex justify-center items-center hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl bg-white dropdown cursor-pointer relative">
        <ViewMoreIcon />
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white rounded-xl text-left w-24 absolute -left-24 -top-7">
            <div className="grid p-1 rounded-t">
              <span
                className="p-1 hover:bg-navhover hover:rounded-lg"
                onClick={() => setShowFile(true)}
              >
                View
              </span>
              {GetAccess("admin_edit") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer"
                  onClick={() => setShowMyModal(true)}
                >
                  Edit
                </span>
              )}
              {GetAccess("admin_edit") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer"
                  onClick={() => setShowPassword(true)}
                >
                  Change Password
                </span>
              )}
              {GetAccess("admin_delete") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg"
                  onClick={() => {
                    handleDelete(data?.userId, data?.name);
                  }}
                >
                  Delete
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <CreateorUpdate
        onClose={handleOnClose}
        visible={showMyModal}
        data={data}
        depList={depList}
        standard={standard}
        refreshData={fetcher}
      />
      <UserProfile data={viewData} onClose={handleClose} visible={showFile} />
      <ChangePassword
        onClose={handlePasswordOnClose}
        visible={showPassword}
        data={data}
        refreshData={fetcher}
      />
    </>
  );
}

export default Viewmore;
